import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { NumericFormat } from 'react-number-format';
import Autocomplete from '@mui/material/Autocomplete';

export default function TankInfoInputs(props) {
  const { t } = useTranslation();
  const {
    formik, transporters, acceptedHeightUnit, acceptedVolumeUnit, update = false,
  } = props;

  return (
    <Paper>
      <Box
        elevation={0}
        sx={{
          p: 3,
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'space-around',
          alignItems: 'flex-start',
        }}
      >

        <FormControl sx={{ backgroundColor: 'white', minWidth: 195 }} disabled={update}>

          <Autocomplete
            freeSolo
            disableClearable
            options={transporters}
            id="transporter"
            name="transporter"
            value={formik.values.transporter}
            onChange={(_, newValue) => {
              formik.setFieldValue('transporter', newValue);
            }}
            renderInput={(params) => (
              <TextField
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...params}
                autoComplete="off"
                label={t('tank_selection.transporter')}
                sx={{ backgroundColor: 'white', minWidth: 195 }}
                variant="outlined"
                value={formik.values.transporter}
                error={formik.errors.transporter && formik.touched.transporter}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={
                  formik.errors.transporter
                  && formik.touched.transporter
                  && formik.errors.transporter
                }
              />
            )}
          />

        </FormControl>
        <TextField
          disabled={update}
          id="tankId"
          name="tankId"
          autoComplete="off"
          variant="outlined"
          label={t('tank_creation.tank_id')}
          value={formik.values.tankId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.tankId && formik.touched.tankId}
          helperText={
            formik.errors.tankId
            && formik.touched.tankId
            && formik.errors.tankId
          }
        />
        <NumericFormat
          id="capacity"
          name="capacity"
          label={t('tank_creation.tank_capacity')}
          className="TextFieldBackground"
          variant="outlined"
          autoComplete="off"
          valueIsNumericString
          allowNegative={false}
          value={formik.values.capacity}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          allowedDecimalSeparators={['.', ',']}
          decimalSeparator="."
          type="text"
          inputProps={{ inputMode: 'decimal' }}
          customInput={TextField}
          error={formik.errors.capacity && formik.touched.capacity}
          helperText={
            formik.errors.capacity
            && formik.touched.capacity
            && formik.errors.capacity
          }
          onValueChange={(values) => {
            formik.handleChange({
              target: {
                name: 'capacity',
                value: values.value,
              },
            });
          }}
        />
      </Box>
      <Box
        elevation={0}
        sx={{
          p: 3,
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'space-around',
          alignItems: 'flex-start',
        }}
      >
        <TextField
          id="certificateNumber"
          name="certificateNumber"
          autoComplete="off"
          variant="outlined"
          label={t('tank_creation.certificate_number')}
          value={formik.values.certificateNumber}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.certificateNumber && formik.touched.certificateNumber}
          helperText={
            formik.errors.certificateNumber
            && formik.touched.certificateNumber
            && formik.errors.certificateNumber
          }
        />
        <TextField
          id="provider"
          name="provider"
          autoComplete="off"
          variant="outlined"
          label={t('tank_creation.gauging_company')}
          value={formik.values.provider}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.provider && formik.touched.provider}
          helperText={
            formik.errors.provider
            && formik.touched.provider
            && formik.errors.provider
          }
        />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDatePicker
            name="gaugeDate"
            id="gaugeDate"
            inputFormat="DD/MM/YYYY"
            label={t('tank_creation.certificate_date')}
            value={formik.values.gaugeDate}
            onChange={(val) => {
              formik.setFieldValue('gaugeDate', val.toDate());
            }}
            renderInput={(params) => (
              <TextField
                sx={{ backgroundColor: 'white' }}
                // #TODO gotta check and solve with magic tool
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...params}
                error={formik.errors.gaugeDate && formik.touched.gaugeDate}
                helperText={
                  formik.errors.gaugeDate
                  && formik.touched.gaugeDate
                  && formik.errors.gaugeDate
                }
              />
            )}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDatePicker
            name="expirationDate"
            id="expirationDate"
            inputFormat="DD/MM/YYYY"
            label={t('admin.validity_date')}
            value={formik.values.expirationDate}
            onChange={(val) => {
              formik.setFieldValue('expirationDate', val.toDate());
            }}
            renderInput={(params) => (
              <TextField
                sx={{ backgroundColor: 'white' }}
                // #TODO gotta check and solve with magic tool
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...params}
                error={formik.errors.expirationDate && formik.touched.expirationDate}
                helperText={
                  formik.errors.expirationDate
                  && formik.touched.expirationDate
                  && formik.errors.expirationDate
                }
              />
            )}
          />
        </LocalizationProvider>

        <FormControl sx={{ backgroundColor: 'white', minWidth: 195 }}>
          <InputLabel id="height-unit-select-label">
            {t('tank_creation.height_unit')}
          </InputLabel>
          <Select
            id="heightUnit"
            name="heightUnit"
            autoComplete="off"
            variant="outlined"
            label={t('tank_creation.height_unit')}
            value={formik.values.heightUnit}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            {acceptedHeightUnit.map((unit, i) => (
              <MenuItem value={unit} key={unit}>
                {unit}
              </MenuItem>
            ))}
          </Select>
          {formik.errors.heightUnit
          && formik.errors.heightUnit && (
            <Typography variant="caption" display="block" color="red">
              {formik.errors.heightUnit}
            </Typography>
          )}
        </FormControl>
        <FormControl sx={{ backgroundColor: 'white', minWidth: 195 }}>
          <InputLabel id="volume-unit-select-label">
            {t('tank_creation.volume_unit')}
          </InputLabel>
          <Select
            id="volumeUnit"
            name="volumeUnit"
            autoComplete="off"
            variant="outlined"
            label={t('tank_creation.volume_unit')}
            value={formik.values.volumeUnit}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            {acceptedVolumeUnit.map((unit, i) => (
              <MenuItem value={unit} key={unit}>
                {unit}
              </MenuItem>
            ))}
          </Select>
          {formik.errors.volumeUnit
            && formik.errors.volumeUnit && (
              <Typography variant="caption" display="block" color="red">
                {formik.errors.volumeUnit}
              </Typography>
          )}
        </FormControl>
      </Box>
    </Paper>
  );
}
